/**
 * UNDO-TRASH-LIGHT — text helper for `registerUndo`.
 *
 * Centralizes the 3 shared strings for the pill ("Undo" button,
 * "Undone" confirmation, and "Couldn't undo that" error) to avoid repeating them at
 * every call site; only "done" (what was done) varies per action.
 */
import { msg } from "@lingui/core/macro";
import type { MessageDescriptor } from "@lingui/core";
import type { UndoMessages } from "./undo";

type TFn = (message: MessageDescriptor, values?: Record<string, unknown>) => string;

export function undoMessages(t: TFn, done: string): UndoMessages {
  return {
    done,
    undoLabel: t(msg`Undo`),
    undone: t(msg`Undone`),
    failed: t(msg`Couldn't undo that`),
  };
}
